import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { DEALERS_ACTION_TYPE } from '../actions';

const initialState = {};

const dealersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case DEALERS_ACTION_TYPE.GET_DEALERS:
        return payload || initialState;

      case DEALERS_ACTION_TYPE.CREATE_DEALER:
      case DEALERS_ACTION_TYPE.EDIT_DEALER:
        draft[payload.id] = payload;
        break;

      case DEALERS_ACTION_TYPE.DELETE_DEALER:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default dealersReducer;
